<template>
  <div class="input-wrapper">
    <div class="input-content">
      <h1>Input New Project</h1>
      <div class="input-row">
        <label for="m_name">Project Name</label>
        <input id="m_name" name="m_name" type="text" v-model="m_name">
      </div>
      <div class="input-row">
        <label for="m_descri">Description</label>
        <!-- <input id="m_descri" name="m_descri" type="text" v-model="m_descri"> -->
        <textarea id="m_descri" name="m_descri" rows="5" cols="20" type="text" v-model="m_descri"></textarea>
      </div>
      <div class="input-row">
        <label for="m_image">Image URL</label>
        <!-- <input id="m_image" name="m_image" type="text" v-model="m_image"> -->
        <textarea id="m_image" name="m_image" rows="2" cols="20" type="text" v-model="m_image"></textarea>
      </div>
      <div class="input-row">
        <label for="m_image">Sort Order</label>
        <input id="m_sort" name="m_sort" type="text" v-model="m_sort">
      </div>

      <button type="submit" @click="addClient">Submit</button>
      <button type="submit" @click="closeAdd" class="closeAdd">Close</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  created () {

  },
  data() {
    return {
      m_name: '',
      m_descri: '',
      m_image: '',
      m_sort: '',
    }
  },
  mounted() {
  },

  methods: {
    getData() {
      axios.get('/api/makers')
        .then((response) => {
          this.makers = response.data
          console.log('success')
        })
    },
    addClient() {
      axios.post('/api/makers', {
        m_name: this.m_name,
        m_descri: this.m_descri,
        m_image: this.m_image,
        m_sort: this.m_sort,
      }).then((response) => {
        console.log(response.data)
        this.m_name = ''
        this.m_descri = ''
        this.m_image = ''
        this.m_sort = ''
       if(response.data.affectedRows == 1) {
          this.getData()
        }
      }).catch(e => {
        console.log(e)
      })
      var modal = document.querySelector('.input-wrapper')
      modal.style.display = "none"
      
    },
     closeAdd() {
      var modal = document.querySelector('.input-wrapper')
      modal.style.display = "none"
    },
  }
}
</script>
<style lang="scss" scoped>
.input-wrapper {
  display: none;
  position: fixed;
  background-color: #eeeeee;
  padding-top: 70px;
  top: 0;
  left: 0;
  width: 100%; 
  height: 100%; 
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,.5);

  .input-content {  
    background-color: #fefefe;
    margin: auto;
    padding: 50px 50px 80px 50px;
    border: 1px solid #888;
    width: 35%;
    .input-row {
      margin-bottom: 20px;
    }
    label {
      width: 180px;
    }
    h1 {
      padding: 10px 10px 30px 10px;
    }
    input {
      width: 100%;
      font-size: 15px;
      padding: 5px;
    }
    textarea {
      border-color:rgb(186,186,186);
      width: 100%;
      font-size: 15px;
      padding: 5px;
    }

    button {
      margin: 15px 0 0 15px;
      background: none;
      padding: 5px 15px;
      width: 100px;
      float: right;
    }
    .closeAdd {
      color: #fff;
      background-color: #eb8b57;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/AddForm.vue